import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import AssetLevelList from 'asset_level/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const AssetLevelListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <AssetLevelList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.asset_level.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('asset_level.title')}
          icon={'bank'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.asset_level.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'asset_level/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <AssetLevelList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <AssetLevelList.Table
              company={company}
              subcompany={subcompany}
              permissions={permissions}
              handleToggle={handleToggle}
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </AssetLevelList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(AssetLevelListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/AssetLevelListView.js